import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const TaxInvoiceAllXML = () => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const token = sessionStorage.getItem("token");
  const companyId = sessionStorage.getItem("companyId");

  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  // 👉 Auto-set first day of month and today's date
  useEffect(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");

    const firstDay = `${year}-${month}-01`;
    const currentDate = today.toISOString().split("T")[0];

    setFromDate(firstDay);
    setToDate(currentDate);
  }, []);

  // -----------------------
  // EXISTING XML DOWNLOAD
  // -----------------------
  const handleXMLDownload = async () => {
    if (!fromDate || !toDate) {
      alert("Please select both dates");
      return;
    }

    Swal.fire({
      title: "Processing...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const response = await axios.post(
        "/api/purple-fusion/taxinvoicexmlfileconverter/XMLGenerateall",
        {
          from_date: fromDate,
          to_date: toDate,
        },
        {
          ...headers,
          responseType: "blob",
        }
      );
      Swal.close();
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      const filename = `TaxInvoice_${fromDate}_to_${toDate}.xml`;
      link.setAttribute("download", filename);

      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error(error);
      Swal.close();
      toast.warn("Error in downloading");
    }
  };

  // -----------------------
  // NEW: EXCEL DOWNLOAD
  // -----------------------
  // const handleExcelDownload = async () => {
  //   if (!fromDate || !toDate) {
  //     alert("Please select both dates");
  //     return;
  //   }

  //   try {
  //     const response = await axios.post(
  //       `/api/purple-fusion/taxinvoicexmlfileconverter/export/tally?invoiceId=0&from=${fromDate}&to=${toDate}&companyId=${companyId}`,
  //       {},
  //       {
  //         ...headers,
  //         responseType: "blob", // VERY IMPORTANT
  //       }
  //     );

  //     const blob = new Blob([response.data], {
  //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     });

  //     const url = window.URL.createObjectURL(blob);
  //     const link = document.createElement("a");
  //     link.href = url;

  //     const filename = `TallyExcel_${fromDate}_to_${toDate}.xlsx`;
  //     link.setAttribute("download", filename);

  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();
  //   } catch (error) {
  //     console.error(error);
  //     alert("Error downloading Excel");
  //   }
  // };

  return (
    <div className="min-h-screen flex justify-center items-start bg-gray-100">
      <div className="bg-white-A700 p-8 rounded-xl shadow-lg w-[30%] mt-5 ">
        <h2 className="text-lg font-bold mb-4 text-center text-blue-700">
          Download XML / Excel
        </h2>

        <label className="block mb-2 font-semibold text-slate-500 text-sm">
          From Date:
        </label>
        <input
          type="date"
          className="w-full border rounded-md p-2 mb-4 text-sm"
          value={fromDate}
            max={toDate}
          onChange={(e) => setFromDate(e.target.value)}
        />

        <label className="block mb-2 font-semibold text-slate-500 text-sm">
          To Date:
        </label>
        <input
          type="date"
          className="w-full border rounded-md p-2 mb-4 text-sm"
          value={toDate}
          min={fromDate}
          onChange={(e) => setToDate(e.target.value)}
        />

        {/* XML Download Button */}
        <button
          onClick={handleXMLDownload}
          className="text-sm w-full bg-green-600 text-white p-2 rounded-md hover:bg-green-700 transition mb-3"
        >
          Download XML
        </button>
        <ToastContainer />
        {/* Excel Download Button */}
        {/* <button
          onClick={handleExcelDownload}
          className="text-sm w-full bg-blue-600 text-white p-2 rounded-md hover:bg-blue-700 transition"
        >
          Download Excel
        </button> */}
      </div>
    </div>
  );
};

export default TaxInvoiceAllXML;
